import React from 'react';
import {compose, graphql} from 'react-apollo';
import {GlobalBanner} from '@homeaway/react-global-messaging';
import {
    GeneralGlobalMessagesQuery,
    GlobalMessagesTravelerStayQuery,
} from './queries';
import translate from '../../utils/translations';

export const GlobalBannerContainer = ({
    conversationGlobalMessages,
    conversationId,
    generalGlobalMessages,
    translations,
}) => {
    const globalMessages = conversationId
        ? conversationGlobalMessages?.getTravelerStay?.booking?.globalMessages
        : generalGlobalMessages?.generalGlobalMessages;
    const loading = conversationId
        ? conversationGlobalMessages?.loading
        : generalGlobalMessages?.loading;
    const error = conversationId
        ? conversationGlobalMessages?.error
        : generalGlobalMessages?.error;
    if (loading || error || !globalMessages) {
        return null;
    }

    return (
        <GlobalBanner
            globalMessages={globalMessages}
            labels={{
                close: translate(
                    translations,
                    'ui-development/shared',
                    'globalMessaging',
                    'shared.globalMessaging.close'
                ),
            }}
        />
    );
};

export default compose(
    graphql(GeneralGlobalMessagesQuery, {
        name: 'generalGlobalMessages',
        options: () => ({
            errorPolicy: 'all',
        }),
        skip: (ownProps) => ownProps.conversationId,
    }),
    graphql(GlobalMessagesTravelerStayQuery, {
        name: 'conversationGlobalMessages',
        options: (ownProps) => ({
            variables: {
                conversationId: ownProps.conversationId,
            },
            errorPolicy: 'all',
        }),
        skip: (ownProps) => !ownProps.conversationId,
    })
)(GlobalBannerContainer);
